module.exports = __webpack_public_path__ + "c_static/img/IMG_1980.71c881a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/截图示范/IMG_1980.jpg
// module id = QWFw
// module chunks = 33